import { RefObject, useCallback } from 'react';

export const useOpenContextMenu = (contextMenuTriggerRef: RefObject<any>) =>
  useCallback((event) => {
    if (!contextMenuTriggerRef.current) {
      return;
    }

    event.persist();
    event.preventDefault();

    setTimeout(() => {
      if (!contextMenuTriggerRef.current) {
        return;
      }

      contextMenuTriggerRef.current.handleContextClick(event);
    }, 0);
  }, []);
